export const ActionTypes = {
	LOGIN_SUCCESS: "LOGIN_SUCCESS",
	LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
	INIT_ACCOUNT: "INIT_ACCOUNT",

	INIT_APP_DATA: "INIT_APP_DATA",
	INIT_PRODUCTS: "INIT_PRODUCTS",
	CONTENT_WRITTEN: "CONTENT_WRITTEN",
	CHECK_INCLUSION_MERKLE: "CHECK_INCLUSION_MERKLE",
	CHECK_BALANCE: "CHECK_BALANCE",

	INIT_SUBMISSIONS: "INIT_SUBMISSIONS",
	UPDATE_SUBMISSION: "UPDATE_SUBMISSION",
};
